import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import containerQueryProps from '../../props/containerQueryProps';
import announcementTypes, { EVENT_TYPE } from './announcementTypes';
import { hexify } from '../../utils';

import './Announcement.scss';

const getStyle = (colors) => {
  const { background, font } = colors;

  return {
    color: hexify(font),
    background: hexify(background),
  };
};

const { HEADER } = announcementTypes;

const AnnouncementBar = ({
  id,
  heading,
  title,
  content,
  primaryLinkUrl,
  primaryLinkText,
  colors,
  containerQuery: { sm },
  event,
}) => {
  useEffect(() => {
    event(EVENT_TYPE.VIEW_ANNOUNCEMENT, {
      type: HEADER,
      title,
      id,
    });
  }, []);

  const handleLinkClick = () => {
    event(EVENT_TYPE.CLICK_ANNOUNCEMENT, {
      type: HEADER,
      title,
      id,
      cta: 'primary',
    });
  };

  return (
    <div
      className={cx('AnnouncementBar', {
        'AnnouncementBar--sm': sm,
      })}
      style={getStyle(colors)}
    >
      <p>
        <span>{`${heading} `}</span>
        <span>{`${title} `}</span>
        <span>{`${content} `}</span>
        {primaryLinkText && (
          <span>
            <a style={{ color: hexify(colors.font) }} onClick={handleLinkClick} href={primaryLinkUrl}>{primaryLinkText}</a>
          </span>
        )}
      </p>
    </div>
  );
};

AnnouncementBar.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  primaryLinkUrl: PropTypes.string,
  primaryLinkText: PropTypes.string,
  colors: PropTypes.shape({
    background: PropTypes.string,
    font: PropTypes.string,
  }),
  containerQuery: containerQueryProps,
  event: PropTypes.func,
};

AnnouncementBar.defaultProps = {
  primaryLinkUrl: null,
  primaryLinkText: null,
  colors: {},
  containerQuery: {},
  event: () => { },
};

AnnouncementBar.displayName = 'AnnouncementBar';
export default AnnouncementBar;
